"use client";

import React, { useEffect } from "react";
import { usePathname } from "next/navigation";

 const ScrollToTop:React.FC = () => {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

export default ScrollToTop;